export class LaboratoryTenantModel {
  declare public code: string;
  declare public demoModeFlag: boolean;
  declare public name: string | null;
  declare public tzDatabaseName: string;
  declare public uuid: string | null | undefined;
}
